import React, { Component } from "react";

class GreyBtn extends Component {
	render() {
		let { cssClass, name, btnClick } = this.props;
		return (
			<button className={"regBtn " + cssClass} onClick={btnClick}>
				{name}
			</button>
		);
	}
}

export default GreyBtn;
